import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { createForm } from '@core/utils';
import { showValidation } from '@shared/ui/utils/form-control-utils/show-validation';

const ERROR_MAP = {
  mandatory: 'required',
};

/**
 * @description Formatted container for a list of inputs
 * @WhereIsItUsed form-container
 */
@Component({
  selector: 'jb-form-wrapper',
  templateUrl: './form-wrapper.component.html',
  styleUrls: ['./form-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormWrapperComponent {
  formData: any;
  form: UntypedFormGroup;
  submitting = false;
  errorMap = ERROR_MAP;

  @Input('content')
  set data(value) {
    this.formData = value;
    if (!!this.formData && this.formData) {
      this.form = createForm(this.fb, this.formData[0]);
    }
  }
  constructor(public fb: UntypedFormBuilder) {}

  updateInputText(value: string): void {
    /* */
  }

  selectChange(val, name): void {
    if (val) {
      this.form.get(name).setValue(val);
    }
  }

  emitValue(val, name): void {
    if (val) {
      this.form.get(name).setValue(val);
    }
  }

  selectStatus(): void {
    /* */
  }

  radioButtonChange(val, name): void {
    if (val) {
      this.form.get(name).setValue(val);
    }
  }

  setValidation(control): void {
    control.markAsTouched();
    control.updateValueAndValidity();
  }

  onSubmit(): void {
    this.submitting = !this.form.valid;
    showValidation(this.form);
  }
}
